type PropsT = {
  className?: string
  strokeColor?: string
}

// Outline gift-box glyph. Path mirrors the restrict-customer modal's "What this means" rows
// (Sketch order-feedback-landing-page v83 `.rst-row svg`).
const GiftOutline = (props: PropsT) => {
  const { className, strokeColor = 'currentColor' } = props

  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke={strokeColor}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="gift-outline-icon"
    >
      <rect x="3" y="8" width="18" height="4" rx="1" />
      <path d="M12 8v13" />
      <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7" />
      <path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5" />
    </svg>
  )
}

export default GiftOutline
